import { useState, useRef } from "react";
import { CssBaseline, Box, Grid } from "@mui/material";
import AppTheme from "../../styles/AppTheme";
import StoreOutTable from "./storeComponents/StoreOutTable";
import StoreOutForm from "./storeComponents/StoreOutForm";

export default function StoreOutItems() {
    const [refreshKey, setRefreshKey] = useState(0);
    const [editRecord, setEditRecord] = useState(null);
    const formRef = useRef(null);

    const triggerRefresh = () => setRefreshKey((k) => k + 1);

    const handleEdit = (row) => {
        setEditRecord(row || null);
        setTimeout(() => formRef.current?.scrollIntoView?.({ behavior: "smooth" }), 100);
    };

    return (
        <AppTheme>
            <CssBaseline />
            <Box
                sx={{
                    mt: 10,
                    pb: 3,
                    mb: 1,
                }}
            >
                <Box sx={{ width: "100%", pr: 1, pb: 3 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box ref={formRef}>
                                <StoreOutForm
                                    onSuccess={triggerRefresh}
                                    editRecord={editRecord}
                                    onClearEdit={() => setEditRecord(null)}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <StoreOutTable refreshKey={refreshKey} onEdit={handleEdit} />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </AppTheme>
    );
}
